module.exports = __webpack_public_path__ + "static/media/left-arrow.d32a4c53.svg";